
import CardBalance from "../components/cardBalance";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { nWithCommas, TEXT_FIN_SESION_JWT } from "../utils";
import {
    toogleLoad, setSaldosFecha, setSaldosMovimientos, setSaldosTrimestrales,
    setTokenSesion, setInfoFondos, showModalFinSesion,
} from "../redux/slices/appslice";
import {
    getSaldosFecha, getMovimientos, getSaldosTrimestrales,
    getInfoFondosWS
} from "../ws";
import { getKeyInfoFondo } from '../firestore';
import CarouselHome from "../components/carousel";


function MisBalances() {
    const dispatch = useDispatch()
    const appData = useSelector((state) => state.appData)
    const [saldosFecha, setSaldosFechaClass] = useState([])

    useEffect(() => {
        dispatch(toogleLoad(true));
        getSF();
        getST();
        getMovi();
        getInfoFondos();

    }, [])


    function orderSaldos(sf) {
        let saldos = []
        for (let saldo of sf) {
            let copy = JSON.parse(JSON.stringify(saldo));
            if (saldo.Producto[0].TipoCliente === 'Fondo de Pensiones') {
                copy['order'] = 3
            }
            if (saldo.Producto[0].TipoCliente === 'Fondo de Ahorro') {
                copy['order'] = 1
            }

            if (saldo.Producto[0].TipoCliente === 'Caja de Ahorro') {
                copy['order'] = 2
            }

            saldos.push(copy)

        }

        saldos.sort((a, b) => a.order - b.order);

        return saldos;
    }


    function getTituloPlan(titulo) {
        if (titulo.toUpperCase() === 'FONDO DE PENSIONES') {
            return 'PLAN DE PENSIONES';
        }

        return titulo;
    }

    const getInfoFondos = async () => {

        if (!appData.infoFondos) {

            let key = await getKeyInfoFondo();


            let result = await getInfoFondosWS(appData, key);

            dispatch(setInfoFondos(result));
        }
    }

    const getSF = async () => {

        if (!appData.saldosFecha) {
            const saldoFecha = await getSaldosFecha(appData, () => {
                dispatch(showModalFinSesion({ texto: TEXT_FIN_SESION_JWT }))
            });

            if (saldoFecha && saldoFecha.Datos && saldoFecha.Datos.length) {
                setSaldosFechaClass(orderSaldos(saldoFecha.Datos))
                dispatch(setSaldosFecha(saldoFecha.Datos));
            }

            if (saldoFecha && saldoFecha.JWT) {
                dispatch(setTokenSesion(saldoFecha.JWT.current_token))
            }
        } else {

            setSaldosFechaClass(orderSaldos(appData.saldosFecha));
        }

        dispatch(toogleLoad(false));
    }

    const getST = async () => {
        dispatch(toogleLoad(true));

        if (!appData.saldosTrimestrales) {

            const saldoTrimestral = await getSaldosTrimestrales(appData, () => {
                dispatch(showModalFinSesion({ texto: TEXT_FIN_SESION_JWT }))
            });
            if (saldoTrimestral && saldoTrimestral.Datos) {
                dispatch(setSaldosTrimestrales(saldoTrimestral.Datos));
            }

            if (saldoTrimestral && saldoTrimestral.JWT) {
                dispatch(setTokenSesion(saldoTrimestral.JWT.current_token))
            }


            dispatch(toogleLoad(false));
        } else {
            dispatch(toogleLoad(false));
        }

    }

    const getMovi = async () => {
        if (!appData.saldosMovimientos) {
            const datosMovimientos = await getMovimientos(appData, () => {
                dispatch(showModalFinSesion({ texto: TEXT_FIN_SESION_JWT }))
            });
            if (datosMovimientos && datosMovimientos.Datos) {
                dispatch(setSaldosMovimientos(datosMovimientos.Datos));
            }
            if (datosMovimientos && datosMovimientos.JWT) {
                dispatch(setTokenSesion(datosMovimientos.JWT.current_token))
            }
        } else {
            dispatch(setSaldosMovimientos(appData.saldosMovimientos));
        }

    }



    return (
        <div className="row">
             <div className="col s12 bannerContent">

             </div>
            <div className="col s12">
                <div className="container">
                    <div className="row">
                        <div className="col s12 mt-2 headerBalances">
                            <div className="row">
                                <div className="col s4" style={{padding:'1.5rem 10px 10px 30px'}}>
                                    <span className="ft-32 secondaty_cyan fw-600 center-align">¡{appData.user.Nombre}!</span>
                                    <p className="txtSecon mt-0">No. empleado: {appData.user.Clave}</p>
                                </div>
                                <div className="col s3">
                                    <span className="ft-32 secondaty_cyan fw-600"></span>
                                </div>
                                <div className="col s5" style={{padding:'1.5rem 40px 10px 10px'}}>
                                    <div className="row containerRecuerda">
                                        <div className="col s2">
                                            <i className="material-icons infoRecuerda">info_outline</i>
                                        </div>
                                        <div className="col s10 ft-14" style={{marginTop:'5px'}}>
                                            Recuerda mantener el control de tu cuenta y
                                            <b> reportar cualquier movimiento extraño.</b>
                                        </div>
                                    </div>
                                </div>

                                <div className="col s12 left-align" style={{marginLeft:'1rem'}}>
                                    <h5 className="txtSecon">Mis Balances</h5>
                                </div>

                                {
                            saldosFecha.length ?
                                saldosFecha.map((v, i) => {
                                    return (
                                        <div className="col s12 l4">
                                            <CardBalance
                                                titulo={getTituloPlan(v.Producto[0].TipoCliente)}
                                                cantidad={`$${nWithCommas(parseFloat(v.TotalLiquidar).toFixed(2))}`}
                                                derechoAdquirido={`$${nWithCommas(parseFloat(v.DerechoAdquirido).toFixed(2))}`}
                                                aportaciones={`$${nWithCommas(parseFloat(v.aportaciones).toFixed(2))}`}
                                                rendimiento={`$${nWithCommas(parseFloat(v.rendimiento).toFixed(2))}`}
                                                saldo={`$${nWithCommas(parseFloat(v.SaldoPrestamos).toFixed(2))}`}
                                                saldoTotal={`$${nWithCommas(parseFloat(v.SubTotal).toFixed(2))}`}
                                            />

                                        </div>
                                    )
                                })

                                : <div className="col s12 center-align">
                                    <h3>Cargando ...</h3>
                                </div>
                        }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col s12">
                <div className="container">
                    <div className="row">
                        <div className="col s12 mt-2">
                            <CarouselHome />
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}


export default MisBalances;